(function () {
  'use strict';

  const configElement = document.getElementById('ElefGiftConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('[Elef Gift] Configuration could not be read.', error);
    return;
  }

  if (!config.enabled || !config.braceletProductId || !config.boxProductId || !config.boxVariantId) return;

  const nativeFetch = window.fetch.bind(window);
  const giftProductIds = new Set([Number(config.braceletProductId), Number(config.boxProductId)]);
  const pendingGiftKey = 'elef-pending-gift-variant';
  const pendingGiftLetterKey = 'elef-pending-gift-letter';
  let cachedCart = null;
  let syncPromise = null;
  let internalRequest = false;

  const cartRequest = (url, options) => {
    internalRequest = true;
    return nativeFetch(url, options).finally(() => {
      internalRequest = false;
    });
  };

  const getCart = async () => {
    const response = await cartRequest('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Sepet okunamadı.');
    cachedCart = await response.json();
    return cachedCart;
  };

  const getGiftLines = (cart, productId) =>
    (cart?.items || []).filter((item) => Number(item.product_id) === Number(productId));

  const getPaidLines = (cart) =>
    (cart?.items || []).filter((item) => !giftProductIds.has(Number(item.product_id)));

  const notifyCartUpdated = (cart, source) => {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'elef-gift-module',
          data: {
            source: source || 'elef-gift-module',
            itemCount: Number(cart?.item_count || 0),
          },
        },
      })
    );
  };

  const changeLine = async (key, quantity) => {
    const response = await cartRequest('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error('Hediye satırı güncellenemedi.');
    cachedCart = await response.json();
    return cachedCart;
  };

  const getPendingGiftVariant = () => {
    try {
      return Number(sessionStorage.getItem(pendingGiftKey) || 0);
    } catch (_) {
      return 0;
    }
  };

  const setPendingGiftVariant = (variantId) => {
    try {
      if (variantId) sessionStorage.setItem(pendingGiftKey, String(variantId));
      else sessionStorage.removeItem(pendingGiftKey);
    } catch (_) {
      // Session storage can be unavailable in strict privacy modes.
    }
  };

  const getPendingGiftLetter = () => {
    try {
      return sessionStorage.getItem(pendingGiftLetterKey) || '';
    } catch (_) {
      return '';
    }
  };

  const setPendingGiftLetter = (letter) => {
    try {
      if (letter) sessionStorage.setItem(pendingGiftLetterKey, letter);
      else sessionStorage.removeItem(pendingGiftLetterKey);
    } catch (_) {
      // Session storage can be unavailable in strict privacy modes.
    }
  };

  const addGiftVariant = async (variantId, type, letter) => {
    const properties = { _elef_gift: type };
    if (type === 'bracelet' && letter) properties.Harf = `${letter} Harfi`;

    const response = await cartRequest('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties,
          },
        ],
      }),
    });
    if (!response.ok) throw new Error('Hediye sepete eklenemedi.');
  };

  const syncGiftLines = async () => {
    if (syncPromise) return syncPromise;

    syncPromise = (async () => {
      let cart = await getCart();
      let didMutateCart = false;
      const paidLines = getPaidLines(cart);
      let braceletLines = getGiftLines(cart, config.braceletProductId);
      let boxLines = getGiftLines(cart, config.boxProductId);

      if (paidLines.length === 0) {
        setPendingGiftVariant(0);
        setPendingGiftLetter('');
        for (const item of [...braceletLines, ...boxLines]) {
          cart = await changeLine(item.key, 0);
          didMutateCart = true;
        }
        if (didMutateCart) notifyCartUpdated(cart, 'elef-gift-cleanup');
        return cart;
      }

      const pendingGiftVariant = getPendingGiftVariant();
      const pendingGiftLetter = getPendingGiftLetter();

      if (pendingGiftVariant) {
        for (const item of braceletLines) {
          if (Number(item.variant_id) !== pendingGiftVariant) {
            cart = await changeLine(item.key, 0);
            didMutateCart = true;
          }
        }

        cart = await getCart();
        braceletLines = getGiftLines(cart, config.braceletProductId);

        if (braceletLines.length === 0) {
          await addGiftVariant(pendingGiftVariant, 'bracelet', pendingGiftLetter);
          didMutateCart = true;
          cart = await getCart();
          braceletLines = getGiftLines(cart, config.braceletProductId);
        }

        setPendingGiftVariant(0);
        setPendingGiftLetter('');
      }

      for (const duplicate of braceletLines.slice(1)) {
        cart = await changeLine(duplicate.key, 0);
        didMutateCart = true;
      }
      for (const duplicate of boxLines.slice(1)) {
        cart = await changeLine(duplicate.key, 0);
        didMutateCart = true;
      }

      cart = await getCart();
      braceletLines = getGiftLines(cart, config.braceletProductId);
      boxLines = getGiftLines(cart, config.boxProductId);

      if (braceletLines[0] && Number(braceletLines[0].quantity) !== 1) {
        cart = await changeLine(braceletLines[0].key, 1);
        didMutateCart = true;
      }
      if (boxLines[0] && Number(boxLines[0].quantity) !== 1) {
        cart = await changeLine(boxLines[0].key, 1);
        didMutateCart = true;
      }

      if (braceletLines.length > 0 && boxLines.length === 0) {
        await addGiftVariant(config.boxVariantId, 'box');
        didMutateCart = true;
        cart = await getCart();
      }

      cachedCart = cart;
      if (didMutateCart) notifyCartUpdated(cart, 'elef-gift-sync');
      return cart;
    })()
      .catch((error) => {
        console.error('[Elef Gift] Cart synchronization failed.', error);
        return cachedCart;
      })
      .finally(() => {
        syncPromise = null;
      });

    return syncPromise;
  };

  const setButtonsBlocked = (form, blocked) => {
    form.querySelectorAll('[ref="addToCartButton"], button[name="add"], button[type="submit"]').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      if (blocked) {
        if (button.dataset.elefGiftDisabled !== 'true') {
          button.dataset.elefGiftWasDisabled = String(button.disabled);
        }
        button.dataset.elefGiftDisabled = 'true';
        button.disabled = true;
        button.setAttribute('aria-describedby', 'ElefGiftSelectionHelp');
      } else if (button.dataset.elefGiftDisabled === 'true') {
        const wasDisabled = button.dataset.elefGiftWasDisabled === 'true';
        delete button.dataset.elefGiftDisabled;
        delete button.dataset.elefGiftWasDisabled;
        if (!wasDisabled) button.disabled = false;
        button.removeAttribute('aria-describedby');
      }
    });
  };

  const markHelp = (selector, isError, missingLetter) => {
    const help = selector.querySelector('[data-elef-gift-help]');
    if (!help) return;
    help.id = 'ElefGiftSelectionHelp';
    help.dataset.error = isError ? 'true' : 'false';
    if (isError && missingLetter) {
      help.textContent = 'Lütfen Harf Bileklik için bir harf seçin.';
    } else {
      help.textContent = isError
        ? 'Lütfen sepete eklemeden önce hediye bileklik modelinizi seçin.'
        : '*Model seçimi zorunludur. Harf Bileklik için harf seçimi de zorunludur.';
    }
  };

  const initializeSelector = async (selector) => {
    if (selector.dataset.configured !== 'true' || selector.dataset.elefInitialized === 'true') return;
    const form = selector.closest('form[action*="/cart/add"]');
    if (!form) return;

    selector.dataset.elefInitialized = 'true';
    let cart;
    try {
      cart = cachedCart || (await getCart());
    } catch (error) {
      console.error('[Elef Gift] Cart state could not be loaded.', error);
    }

    selector.dataset.giftInCart = String(getGiftLines(cart, config.braceletProductId).length > 0);
    const radios = Array.from(selector.querySelectorAll('input[name="elef-gift-variant"]'));
    const selectedRadio = () => radios.find((radio) => radio.checked);
    const lettersFieldset = selector.querySelector('[data-elef-gift-letters]');
    const letterRadios = Array.from(selector.querySelectorAll('[data-elef-gift-letter]'));
    const selectedLetter = () => letterRadios.find((radio) => radio.checked);
    const needsLetter = () => selectedRadio()?.dataset.giftRequiresLetter === 'true';
    const dialog = selector.querySelector('[data-elef-gift-dialog]');
    const dialogImage = dialog?.querySelector('[data-elef-gift-dialog-image]');
    const dialogTitle = dialog?.querySelector('[data-elef-gift-dialog-title]');

    const closePreview = () => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    selector.querySelectorAll('[data-elef-gift-preview]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!dialog || !dialogImage || !dialogTitle) return;

        const title = button.dataset.previewTitle || 'Hediye bileklik';
        dialogImage.src = button.dataset.previewImage || '';
        dialogImage.alt = title;
        dialogTitle.textContent = title;

        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    });

    dialog?.querySelector('[data-elef-gift-dialog-close]')?.addEventListener('click', closePreview);
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closePreview();
    });

    const updateButtonState = () => {
      const showLetters = needsLetter();
      if (lettersFieldset) lettersFieldset.hidden = !showLetters;
      letterRadios.forEach((radio) => {
        radio.disabled = !showLetters;
        radio.required = showLetters;
      });

      const blocked =
        selector.dataset.giftInCart !== 'true' && (!selectedRadio() || (showLetters && !selectedLetter()));
      setButtonsBlocked(form, blocked);
      markHelp(selector, false);
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', updateButtonState);
    });
    letterRadios.forEach((radio) => {
      radio.addEventListener('change', updateButtonState);
    });

    form.addEventListener(
      'submit',
      (event) => {
        const hasBracelet = getGiftLines(cachedCart, config.braceletProductId).length > 0;
        if (hasBracelet) return;

        const giftVariant = selectedRadio();
        if (!giftVariant) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          markHelp(selector, true);
          selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        if (giftVariant.dataset.giftRequiresLetter === 'true' && !selectedLetter()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          markHelp(selector, true, true);
          lettersFieldset?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const giftLetter = giftVariant.dataset.giftRequiresLetter === 'true' ? selectedLetter()?.value || '' : '';
        setPendingGiftVariant(giftVariant.value);
        setPendingGiftLetter(giftLetter);

        // Harf yalnızca hediye bileklik satırında görünmelidir; ana ürün formuna gönderilmez.
        letterRadios.forEach((radio) => {
          radio.disabled = true;
        });
        window.setTimeout(() => {
          if (!needsLetter()) return;
          letterRadios.forEach((radio) => {
            radio.disabled = false;
          });
        }, 0);
      },
      true
    );

    updateButtonState();

    document.addEventListener('variant:update', () => window.setTimeout(updateButtonState, 0));
    document.addEventListener('product:variant-change', () => window.setTimeout(updateButtonState, 0));
  };

  const init = () => {
    document.querySelectorAll('[data-elef-gift-selector]').forEach(initializeSelector);
  };

  const originalWindowFetch = window.fetch;
  window.fetch = async function () {
    const args = Array.from(arguments);
    const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const response = await originalWindowFetch.apply(this, args);

    if (!internalRequest && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(requestUrl)) {
      window.setTimeout(syncGiftLines, 250);
      window.setTimeout(syncGiftLines, 900);
    }

    return response;
  };

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
